import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, User, Calendar, UserPlus, Clipboard } from "lucide-react";
import "./BottomNavigation.css";


const BottomNavigationAdmin = () => {
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(window.scrollY);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        const handleScroll = () => {
            if (window.scrollY > lastScrollY) {
                setIsVisible(false); // Hide when scrolling down
            } else {
                setIsVisible(true); // Show when scrolling up
            }
            setLastScrollY(window.scrollY);
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    if (!isMobile) return null; // Hide on larger screens

    return (
        <div className={`bottom-nav ${isVisible ? "visible" : "hidden"}`}>
            <Link to="/admin/dashboard" className={`nav-item-mobile ${location.pathname === "/admin/dashboard" ? "active" : ""}`}>
                <Home size={24} />
                <span>Home</span>
            </Link>
            <Link to="/admin/office/attendance-report" className={`nav-item-mobile ${location.pathname === "/admin/student-attendance" ? "active" : ""}`}>
                <Calendar size={24} />
                <span>Attendance</span>
            </Link>
            <Link to="/admin/office/staff" className={`nav-item-mobile ${location.pathname === "/admin/new-student" ? "active" : ""}`}>
                <UserPlus size={24} />
                <span>Staffs</span>
            </Link>
            <Link to="/admin/salesandleads/leads" className={`nav-item-mobile ${location.pathname === "/" ? "active" : ""}`}>
                <User size={24} />
                <span>Leads</span>
            </Link>
            <Link to="/staff/projectsandtasks/scheduledtasks" className={`nav-item-mobile ${location.pathname === "/admin/profile" ? "active" : ""}`}>
                <Clipboard size={24} />
                <span>Tasks</span>
            </Link>
        </div>
    );
};

export default BottomNavigationAdmin;
